






















































































import { Component, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwDashSwitchOption } from './types';

const cssPrefix = 'sw-dash-switch';

/**
 * Events:
 * @event on-switch `(id: string)`
 */
@Component({
  components: {
  },
})
export default class SwDashSwitch extends SwExtendedVue {
  /** could be `light` or `dark` */
  @Prop({ type: String, default: 'light' })
  theme: string;

  /** could be `bar` or `dot` */
  @Prop({ type: String, default: 'bar' })
  type: string;

  @Prop({ type: Array, required: true })
  options: SwDashSwitchOption[];

  @Model('on-switch', { type: String, required: true })
  selected: string;

  @Prop({ type: Number, default: 15 })
  clickAreaHeight: number;

  cssPrefix: string = cssPrefix;

  get clickAreaPadding(): string {
    return `${Math.floor((this.clickAreaHeight - 5) / 2)}px`;
  }

  isSelected(option: SwDashSwitchOption): boolean {
    return (option.id === this.selected);
  }

  onClickOption(option: SwDashSwitchOption) {
    if (this.isSelected(option)) { return; }
    this.$emit('on-switch', option.id);
  }
}
